"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SERVICE_NAMES = void 0;

/* eslint-disable import/prefer-default-export */
var SERVICE_NAMES = {
  RESOURCE_CENTER: 'RESOURCE_CENTER',
  COMPATIBILITY_GUIDE: 'COMPATIBILITY_GUIDE',
  PEP: 'PEP'
};
exports.SERVICE_NAMES = SERVICE_NAMES;